// @flow
import { InvoicesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    listaFacturas: [],
    loading: false,
    error: false,
    formSubmited: false
};

type InvoicesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { mantenimiento?: {} | null, listaMantenimientos?: [] | null, listaFacturas?: [] | null, loading?: boolean, +value ?: boolean };

const Invoices = (state: State = INIT_STATE, action: InvoicesAction): any => {
    // console.log(action);
    switch (action.type) {
        case InvoicesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case InvoicesActionTypes.LIST_INVOICES_BY_CLIENT: {
                    return {
                        ...state,
                        listaFacturas: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case InvoicesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {

                case InvoicesActionTypes.LIST_INVOICES_BY_CLIENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaFacturas: [],
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case InvoicesActionTypes.LIST_INVOICES_BY_CLIENT:
            return { ...state, error: false, loading: true };
        case InvoicesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                listaFacturas: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Invoices;
